import PropTypes from 'prop-types';
import React from 'react';
import {
  Row,
  Col,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { categoriesProducts } from '../reducers/categoriesProductsReducer'
import Catlist from './Catlist';
import ShopByBrand from './shop-by-brand';
const propTypes = {
  sendOneKeyword: PropTypes.func.isRequired, 
  gender: PropTypes.string.isRequired, 
  itemsListByGender: PropTypes.array.isRequired, 
  handleSubMenuExit: PropTypes.func.isRequired
}


const styles = {
  subMenu: {
    width: '100%',
    backgroundColor:'rgba(255, 255, 255, 0.9)',
    backdropFilter:'blur(6px)',
    position: 'absolute', 
    left:'0', 
    zIndex:'2'
  },
  subMenuImage: {
    width: '100%',
    maxHeight: '300px',
    padding:'70px'
  },
  subMenuCategories: {
    paddingTop:'70px'
  },
  subMenuCategoriesUl: {
    listStyleType: 'none',
    fontSize: '15px'
  },
  subMenuCategory: {
    color: '#343a40'
  }
}
const Submenu = ({
  sendOneKeyword,  
  handleSubMenuExit
}) => (
  
  <div className="px-3" style={styles.subMenu} onMouseLeave={handleSubMenuExit}>
    <div> <p className="font-weight-bold mt-2">Search For Brands, Items & Categories</p></div>
    <Row>
      <Col md="6">
        <Catlist/>
      </Col>
        <Col md="6" className="p-3">
          <h4>SHOP BY PRICE </h4>
         <div className="py-1"> <Link to={`/productslist?pricecap=199`} style={{color:'#000'}}> UNDER 199 </Link> </div>
         <div className="py-1"> <Link to={`/productslist?pricecap=299`} style={{color:'#000'}}> UNDER 299 </Link> </div>
         <div className="py-1"> <Link to={`/productslist?pricecap=399`} style={{color:'#000'}}> UNDER 399 </Link> </div>
         <div className="py-1"> <Link to={`/productslist?pricecap=499`} style={{color:'#000'}}> UNDER 499 </Link> </div>
         <div className="py-1"> <Link to={`/productslist?pricecap=599`} style={{color:'#000'}}> UNDER 599 </Link> </div>
        </Col>
    </Row>
  </div>
);

Submenu.propTypes = propTypes;

export default Submenu;



// WEBPACK FOOTER //
// ./src/components/Submenu.js